export default __webpack_public_path__ + "static/media/android.1df5cde6.svg";